<template lang="pug">
.profile-icon-wrapper(v-if="me")
  .profile-icon(@click="showMenuList = true" @mouseleave="showMenuList = false") {{me.firstName[0]}}{{me.lastName[0]}}
    .menu-list-wrapper
      .menu-list(v-if="showMenuList")
        .ml-item(@click="$router.push({name: 'Profile'})") Profil öffnen
        .ml-item(@click="logout()") Ausloggen
</template>

<script>
export default {
  data() {
    return {
      showMenuList: false
    };
  },
  computed: {
    me() {
      return this.$store.state.me.me
    }
  },
  methods: {
    logout() {
      this.$store.dispatch("auth/logout", this.$router);
    }
  }
};
</script>

<style lang="scss" scoped>
.profile-icon {
  position: relative;
  height: 32px;
  width: 32px;
  background-color: pink;
  font-weight: 500;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  border: solid 2px rgba($primary, 0.16);
  margin: 0 $sm-space;
  &:hover {
    cursor: pointer;
    border: solid 2px rgba($primary, 1);
  }

  .menu-list-wrapper {
    position: absolute;
    top: 0%;
    right: 0;
    padding-top: 100%;
  }

  .menu-list {
    position: relative;
    z-index: 4;
    min-width: 160px;
    background-color: white;
    box-shadow: $shadow-md;
    border-radius: 4px;
    border: solid 1px $light;
    .ml-item {
      text-align: center;
      padding: $sm-space;
      &:hover {
        background-color: $light;
      }
    }
  }
}
</style>